import { useQuery } from "react-query";
import {
  fetchSprintDeliveryCost,
  ISprintDeliveryCost,
} from "../api/aiMetricsApi";
import { ADO_QUERY_KEYS } from "./adoQueryKeys";

const STALE_TIME = 5 * 60 * 1000;

/**
 * Per-sprint throughput, velocity and AI spend for the selected teams.
 *
 * Single query, no prior-period twin: the chart already shows every sprint in
 * the window side by side, so a second window would duplicate the same bars.
 *
 * `isSplitByTeam` asks the API for one row per sprint *and* team instead of the
 * selected teams collapsed together. It is part of the query key, so the two
 * views are cached side by side and switching back is instant.
 */
export const useSprintDeliveryCost = (
  teams: string[],
  startDate: Date,
  endDate: Date,
  sprints: string[] = [],
  isSplitByTeam = false,
) => {
  const sortedTeams = JSON.stringify([...teams].sort());
  const sortedSprints = JSON.stringify([...sprints].sort());

  return useQuery<ISprintDeliveryCost, Error>(
    [
      ADO_QUERY_KEYS.sprintDeliveryCost,
      sortedTeams,
      startDate.toISOString(),
      endDate.toISOString(),
      sortedSprints,
      isSplitByTeam,
    ],
    () =>
      fetchSprintDeliveryCost(
        teams,
        startDate,
        endDate,
        sprints,
        isSplitByTeam,
      ),
    { staleTime: STALE_TIME, enabled: teams.length > 0 },
  );
};
